// Polymarket Polygon contract addresses + minimal ABIs.
//
// Source: https://github.com/Polymarket/clob-client (src/config.ts MATIC_CONTRACTS,
// fetched 2026-05). USDC.e is the PoS bridged USDC at 0x2791... and is what
// Polymarket settles in; the native USDC at 0x3c499... is not the one to
// approve. Standard CTF Exchange covers most markets; PR 7 can layer in the
// neg-risk exchange (0xC5d5...) for /trade-api/v2 neg-risk markets.

import type { Address } from 'viem';

export const POLYGON_CHAIN_ID = 137;

// USDC.e (PoS bridged collateral)
export const USDC_ADDRESS: Address = '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' as Address;
// Conditional Tokens Framework (ERC-1155)
export const CTF_ADDRESS: Address = '0x4D97DCd97eC945f40cF65F87097ACe5EA0476045' as Address;
// CTF Exchange — the address that needs the allowances.
export const CTF_EXCHANGE_ADDRESS: Address = '0x4bFb41d5B3570DeFd03C39a9A4D8dE6Bd8B8982E' as Address;
// Neg-risk exchange — same allowances also need to point here for
// neg-risk markets. PR 7 wires this in once the order-submission path
// knows which exchange a given market uses.
export const NEG_RISK_CTF_EXCHANGE_ADDRESS: Address =
  '0xC5d563A36AE78145C45a50134d48A1215220f80a' as Address;

export const ERC20_ABI = [
  {
    name: 'allowance',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'approve',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'value', type: 'uint256' },
    ],
    outputs: [{ type: 'bool' }],
  },
] as const;

export const ERC1155_ABI = [
  {
    name: 'isApprovedForAll',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { name: 'account', type: 'address' },
      { name: 'operator', type: 'address' },
    ],
    outputs: [{ type: 'bool' }],
  },
  {
    name: 'setApprovalForAll',
    type: 'function',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'operator', type: 'address' },
      { name: 'approved', type: 'bool' },
    ],
    outputs: [],
  },
] as const;

// Unlimited approval. The Polymarket UI uses MAX_UINT256 too — avoids
// per-order re-approves and the exchange contract is audited.
export const MAX_UINT256 = 2n ** 256n - 1n;
